import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import XLSX from "xlsx";
import {
  addTransporterData,
  addAggregateTransporterData,
  add5MTransporterData,
} from "../../../services/TransporterDataService";
import { DailyReportFilterForTransporterData } from "../../../utils/dataFilter";
import { getTransporterData } from "../../../services/TransporterDataService";
import { includes } from "lodash";
import { dispatcher } from "../../../store/storeHelpers";
import * as actionTypes from "../../../store/ActionTypes"
import { getCarrierwiseContainerCount } from "../../../services/TransporterDataService";
import { formatCarrierwiseContainerCount } from "../../../utils/dataFilter";
import Select from "react-select";
import { getPickupLocation } from "../../../services/VGMService";

function UploadTransporterData({ show, handleClose, setData, setNoDataState, date, setDate, setCarrierList }) {
  const [planDate, setPlanDate] = useState({
    fromdate: moment().format("YYYY-MM-DD"),
    todate: moment().format("YYYY-MM-DD"),
  });
  const [excelData, setExcelData] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [pickupLocation, setPickupLocation] = useState([]);
  const [containerValue, setCotainerValue] = useState({
    pick_up_location: "",
  });

  useEffect(() => {
    const requestPickupLocation = async () => {
      const response = await getPickupLocation();
      setPickupLocation(response.data);
    };
    requestPickupLocation()
  }, []);

  const readInputFile = (e) => {
    if (e.target.files.length !== 0) {
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary", cellDates: true });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse = XLSX.utils.sheet_to_json(ws);
        const headerDatas = XLSX.utils.sheet_to_json(ws, { header: 1 });
       
let spaceRemoved = false;

const cleanedData = dataParse.map(row => {
  if (row['CONTAINER NO']) {
    const originalValue = row['CONTAINER NO'].toString();
    const cleanedValue = originalValue.replace(/\s+/g, '');

    if (originalValue !== cleanedValue) {
      spaceRemoved = true; // 🔔 space detected & removed
    }

    row['CONTAINER NO'] = cleanedValue;
  }
  return row;
});

const invalidRows = cleanedData.filter(row => {
  const columnValue = row['CONTAINER NO'];

  if (columnValue && columnValue.length === 11) {
    const firstPart = columnValue.substring(0, 4);
    const lastPart = columnValue.substring(4);

    return (
      !/^[A-Za-z]{4}$/.test(firstPart) ||
      !/^\d{7}$/.test(lastPart)
    );
  }
  return true;
});

if (invalidRows.length > 0) {
  setLoading(true);
  toast.error('Container Number must contain 4 letters followed by 7 digits');
  handleClose();
} else {
  setLoading(false);

  if (spaceRemoved) {
    toast.info('Spaces were removed from Container Number.');
  }

  setExcelData(cleanedData);
}


       

      
        if (includes(f["name"], "Universal")) {
          if (headerDatas[0][0] !== "MODULE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MODULE'");
          }
          if (headerDatas[0][1] !== "VEHICLE NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'VEHICLE NO'");
          }
          if (headerDatas[0][2] !== "FLEETX LR NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'FLEETX LR NO'");
          }
          if (headerDatas[0][3] !== "CUSTOMER") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CUSTOMER'");
          }
          if (headerDatas[0][4] !== "BOOKING NO.") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'BOOKING NO.'");
          }
          if (headerDatas[0][5] !== "CONTAINER NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONTAINER NO'");
          }
          if (headerDatas[0][6] !== "CONSIGNEE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONSIGNEE'");
          }
          if (headerDatas[0][7] !== "CONSINOR NAME") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONSINOR NAME'");
          }
          if (headerDatas[0][8] !== "CLEARANCE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CLEARANCE'");
          }
          if (headerDatas[0][9] !== "EMPTY YARD") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'EMPTY YARD'");
          }
          if (headerDatas[0][10] !== "MOVEMENT TYPE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MOVEMENT TYPE'");
          }
          if (headerDatas[0][11] !== "SEAL NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'SEAL NO'");
          }
          if (headerDatas[0][12] !== "DRIVER NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'DRIVER NO'");
          }
         
        }
        if (includes(f["name"], "Maersk")) {
          if (headerDatas[0][0] !== "MODULE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MODULE'");
          }
          if (headerDatas[0][1] !== "VEHICLE NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'VEHICLE NO'");
          }
          if (headerDatas[0][2] !== "FLEETX LR NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'FLEETX LR NO'");
          }
          if (headerDatas[0][3] !== "CONTAINER NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONTAINER NO'");


          }

          if (headerDatas[0][4] !== "SIZE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'SIZE'");
          }
          if (headerDatas[0][5] !== "TYPE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'TYPE'");
          }
          if (headerDatas[0][6] !== "LINE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'LINE'");
          }
          if (headerDatas[0][7] !== "BOOKING NO.") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'BOOKING NO.'");
          }
          if (headerDatas[0][8] !== "CONSIGNEE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONSIGNEE'");
          }
          if (headerDatas[0][9] !== "CONSINOR NAME") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONSINOR NAME'");
          }
          if (headerDatas[0][10] !== "MOVEMENT TYPE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MOVEMENT TYPE'");
          }
          if (headerDatas[0][11] !== "SEAL NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'SEAL NO'");
          }
          if (headerDatas[0][12] !== "DRIVER NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'DRIVER NO'");
          }
        }
        if (includes(f["name"], "Hapag")) {
          if (headerDatas[0][0] !== "MODULE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MODULE'");
          }
          if (headerDatas[0][1] !== "DATE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'DATE'");
          }
          if (headerDatas[0][2] !== "VEHICLE NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'VEHICLE NO'");
          }
          if (headerDatas[0][3] !== "CUSTOMER") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CUSTOMER'");
          }
          if (headerDatas[0][4] !== "BOOKING NO.") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'BOOKING NO.'");
          }
          if (headerDatas[0][5] !== "CONTAINER NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CONTAINER NO'");
          }
          if (headerDatas[0][6] !== "SEAL NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'SEAL NO'");
          }
          if (headerDatas[0][7] !== "SIZE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'SIZE'");
          }
          if (headerDatas[0][8] !== "EMPTY YARD") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'EMPTY YARD'");
          }
          if (headerDatas[0][9] !== "CLEARANCE") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'CLEARANCE'");
          }
          if (headerDatas[0][10] !== "MOB NO") {
            setDisableSubmit(true);
            toast.error("Excel Column Heading should be 'MOB NO'");
          }
        }
      };
      reader.readAsBinaryString(f);
    }
  };

  const handleSubmit = async () => {
    var tractorMount = false;
    var aggMount = false;
    var fiveMMount = false;
    setLoading(true);

    const dataReport = await DailyReportFilterForTransporterData(
      excelData,
      planDate,
      containerValue
    );

    if (dataReport.is_valid === true) {
      try {

        if (dataReport.filteredTractorData.length > 0) {

          try {
            await addTransporterData(dataReport.filteredTractorData);
            const response = await getTransporterData(planDate);
            setNoDataState(false);
            dispatcher(actionTypes.TRANSPORTER_LOADING, response);
            setData(response);
            setPickupLocation([])
            tractorMount = true;
          } catch (error) {
            setLoading(false);
            setNoDataState(true);
            tractorMount = false;
            toast.error(
              "Unable to upload tractor data"
            );
          }
        }

        if (dataReport.filteredAggregateData.length > 0) {
          try {
            await addAggregateTransporterData(dataReport.filteredAggregateData);
            const response = await getTransporterData(planDate);
            setNoDataState(false);
            dispatcher(actionTypes.TRANSPORTER_LOADING, response);
            setData(response);
            setPickupLocation([])
            aggMount = true;
          } catch (error) {
            setLoading(false);
            setNoDataState(true);
            aggMount = false;
            toast.error(
              "Unable to upload aggregate data"
            );
          }
        }
        if (dataReport.filtered5MData.length > 0) {
          try {
            await add5MTransporterData(dataReport.filtered5MData);
            const response = await getTransporterData(planDate);
            setNoDataState(false);
            dispatcher(actionTypes.TRANSPORTER_LOADING, response);
            setData(response);
            setPickupLocation([])
            fiveMMount = true;
          } catch (error) {
            setLoading(false);
            setNoDataState(true);
            fiveMMount = false;
            toast.error(
              "Unable to upload 5M data"
            );
          }
        }
        if (tractorMount || aggMount || fiveMMount) {
          const counterResponse = await getCarrierwiseContainerCount(planDate);
          setCarrierList(formatCarrierwiseContainerCount(counterResponse.data));
          setLoading(false);
          setDate(planDate)
          handleClose();
          toast.success("Transporter data uploaded successfully");
        } else {

          if (excelData.length === 0) {
            toast.error("Please select a valid file for upload");
          }
          else {
            setLoading(false);
            toast.error("Booking number not found");
          }

        }
      } catch (error) {
        setLoading(false);
        toast.error("Unable to upload transporter data");
      }
    } else toast.error("Some columns are missing");
  };

  return (
    <>
      <Modal show={show} backdrop="static" onHide={handleClose} centered>
        <Modal.Body>
          <h4>Upload Transporter File</h4>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Form.Group>
                <Form.Label style={{ fontWeight: "500" }}>OFP Plan Date</Form.Label>
                <Form.Control
                  type="date"
                  className="hiden-inp modal-date-picker-custon"
                  style={{ width: "100%" }}
                  value={planDate.fromdate}
                  onChange={(e) =>
                    setPlanDate({ ...planDate, fromdate: e.target.value, todate: e.target.value })
                  }
                />
              </Form.Group>
            </div>
            {/* <div> */}
            {/* <div>
              <Form.Label style={{ fontWeight: "500" }}>
                Pick Up Location
              </Form.Label>
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                getOptionLabel={(location) => location.Pickup_Location}
                getOptionValue={(location) => location.Pickup_Location}
                options={pickupLocation}
                placeholder="Select Location..."
                className="transporter_pickup_location_dropdown"
                maxMenuHeight={200}
                name="pick_up_location"
                value={{
                  Pickup_Location: containerValue.pick_up_location,
                }}
                onChange={(option) =>
                  setCotainerValue({
                    ...containerValue,
                    pick_up_location: option["Pickup_Location"],
                  })
                }
              />
            </div> */}
          </div>
          <Form.Group className="mb-3">
            <Form.Control
              type="file"
              className="file-modal-input"
              onChange={(e) => readInputFile(e, "daily")}
            />
          </Form.Group>
          <Button
            className="fr btn-sm"
            onClick={handleSubmit}
            disabled={disableSubmit || loading}
          >
            {loading ? "Uploading" : "Upload"}
          </Button>
          <Button
            className="fr mr-1 btn-sm"
            variant="outline-primary"
            onClick={() => {
              handleClose();
              setExcelData("");
              setDisableSubmit(false);
              setPickupLocation([])
            }}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UploadTransporterData;
